import { render } from "./DsDialog.vue?vue&type=template&id=76848cce&scoped=true"
import script from "./DsDialog.vue?vue&type=script&lang=js"
export * from "./DsDialog.vue?vue&type=script&lang=js"

import "./DsDialog.vue?vue&type=style&index=0&id=76848cce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76848cce"]])

export default __exports__